// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-btn[data-v-58519d48],div[data-v-58519d48]{margin:auto}.login-btn[data-v-58519d48]{background-color:#fff;height:45px;width:186px;border-radius:15px;font-size:large!important}.login-icon[data-v-58519d48]{background-color:var(--v-text-base);border-radius:50%;height:25px!important;width:25px!important}", ""]);
// Exports
module.exports = exports;
